'use client';

import { FC } from 'react';

type HighlightMatchProps = {
  text: string;
  query: string;
};

export const HighlightMatch: FC<HighlightMatchProps> = ({ text, query }) => {
  if (!query) return <>{text}</>;
  const index = text.toLowerCase().indexOf(query.toLowerCase());
  if (index === -1) return <>{text}</>;
  return (
    <>
      {text.slice(0, index)}
      <strong>{text.slice(index, index + query.length)}</strong>
      {text.slice(index + query.length)}
    </>
  );
};
